import styled from "styled-components"

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 8px 12px 20px;
`

export const IconBadge = styled.div`
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: rgba(55, 133, 88, 0.14);
  margin-bottom: 10px;

  svg {
    width: 28px;
    height: 28px;
    color: ${({ theme }) => theme.colors.green.main};
  }
`

export const WarningIconBadge = styled.div`
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #fbd61840;
  margin-bottom: 10px;

  svg {
    width: 28px;
    height: 28px;
    color: #b45309;
  }
`

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.5;
  max-width: 320px;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
`

export const InputWrapper = styled.div`
  position: relative;
`

export const InputIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: grid;
  place-items: center;
  pointer-events: none;
  color: #9ca3af;

  svg {
    width: 18px;
    height: 18px;
  }
`

export const HelperText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
`

export const ErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #dc2626;
`

export const Actions = styled.div<{ $vertical?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 12px;
  padding: 20px 0 4px;
`

export const CancelButton = styled.button`
  outline: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.6rem 0.4rem;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  transition: color 0.2s;

  &:hover {
    color: #374151;
  }
`

export const Button = styled.button<{ $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  outline: none;
  background-color: ${({ $disabled, theme }) =>
    !$disabled ? theme.colors.green.main : "#CBD5E1"};
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  padding: 0.7rem 1.6rem;
  min-height: 52px;
  width: 100%;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  transition:
    box-shadow 0.2s,
    background-color 0.2s;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    box-shadow: ${({ $disabled }) =>
      $disabled ? "none" : "0 4px 12px rgba(55, 133, 88, 0.3)"};
  }
`

export const Spinner = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: askphone-spin 0.7s linear infinite;

  @keyframes askphone-spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 20px 12px 28px;
`

export const SuccessIcon = styled.div`
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: rgba(55, 133, 88, 0.12);
  margin-bottom: 4px;

  svg {
    width: 30px;
    height: 30px;
    color: ${({ theme }) => theme.colors.green.main};
  }
`

export const SuccessMessage = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`

export const SuccessSubtext = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
`
